// import React, { useState } from "react";
import {
    useTranslate,
    IResourceComponentsProps,
    CrudFilters,
    HttpError,
} from "@pankod/refine-core";

import {
    List,
    Table,
    // Avatar,
    useTable,
    DateField,
    // BooleanField,
    Card,
    CreateButton,
    Input,
    Icons,
    Form,
    DatePicker,
    Button,
    Select,
    FilterDropdown,
    FormProps,
    Row,
    Col,
    // ShowButton,
    EditButton,
    useSelect,
    useDrawerForm,
} from "@pankod/refine-antd";

// import { IUser, IUserFilterVariables } from "../../interfaces";
import { IProfile, IUserFilterVariables, IOrganization } from "interfaces";

import { CreateProfile, EditProfile } from "components/profile";

export const UserList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, searchFormProps } = useTable<
    IProfile,
    HttpError,
    IUserFilterVariables
  >({
    resource: "profiles",
    initialSorter: [{
      field: "username",
      order: "asc",
    }],
    metaData: {
      // select: "*",
      select: "*, organizations!fk_profiles_organizations(id, title)",
      // select: "*, organizations:organization_id(id, title)",
    },
    onSearch: (params) => {
            const filters: CrudFilters = [];
            const { q, created_at } = params;
            // const { q, status, created_at, gender, is_active } = params;

            filters.push({
              field: "q",
              operator: "eq",
              value: q,
            });

            filters.push(
                {
                  field: "createdAt",
                  operator: "gte",
                  value: created_at
                        ? created_at[0].startOf("day").toISOString()
                        : undefined,
                },
                {
                  field: "createdAt",
                  operator: "lte",
                  value: created_at
                        ? created_at[1].endOf("day").toISOString()
                        : undefined,
                },
            );
            // filters.push({
            //     field: "status.text",
            //     operator: "eq",
            //     value: status,
            // });

            return filters;
        },
        syncWithLocation: false,
    });

  const t = useTranslate();

  const {
    drawerProps: createDrawerProps,
    formProps: createFormProps,
    saveButtonProps: createSaveButtonProps,
    show: createShow,
  } = useDrawerForm<IProfile>({
    action: "create",
    resource: "profiles",
    redirect: false,
  });

  const {
    drawerProps: editDrawerProps,
    formProps: editFormProps,
    saveButtonProps: editSaveButtonProps,
    show: editShow,
  } = useDrawerForm<IProfile>({
    action: "edit",
    resource: "profiles",
    redirect: false,
    
    // warnWhenUnsavedChanges: true,
  });

  // Show Drawer
  // const [visibleShowDrawer, setVisibleShowDrawer] = useState<boolean>(false);
  // const { queryResult, showId, setShowId } = useShow<IPost>();

  const { selectProps } = useSelect<IOrganization>({
    resource: "organizations",
  });

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col xl={6} lg={24} xs={24}>
                <Card title={t("users.filter.title")}>
                  <Filter formProps={searchFormProps} />
                </Card>
                {/* <CreateButton onClick={() => createShow()}> {t("stores.buttons.addProduct")}</CreateButton> */}
        </Col>
        <Col xl={18} xs={24}>
        <List pageHeaderProps={{ extra: <CreateButton onClick={() => createShow()}> {t("users.titles.create")}</CreateButton> }}>
            <Table {...tableProps} rowKey="id">
                        {/* <Table.Column
                            key="gsm"
                            dataIndex="gsm"
                            title={t("users.fields.gsm")}
                        /> */}
                        {/* <Table.Column
                            align="center"
                            key="avatar"
                            dataIndex={["avatar"]}
                            title={t("users.fields.avatar.label")}
                            render={(value) => <Avatar src={value[0].url} />}
                        /> */}
                        {/* <Table.Column
                            key="firstName"
                            dataIndex="firstName"
                            title={t("users.fields.firstName")}
                        /> */}
                        {/* <Table.Column
                            key="lastName"
                            dataIndex="lastName"
                            title={t("users.fields.lastName")}
                        /> */}
                        <Table.Column
                            key="username"
                            dataIndex="username"
                            title={t("users.fields.username")}
                        />
                        <Table.Column
                            key="role"
                            dataIndex="role"
                            title={t("users.fields.role")}
                            render={(value) =>
                              t(`role.${value}`)
                            }
                        />
                        <Table.Column
                            key="organization_id"
                            dataIndex={["organizations", "title"]}
                            title={t("users.fields.organization")}
                            filterDropdown={(props) => (
                              <FilterDropdown {...props}>
                                <Select
                                  style={{ minWidth: 200 }}
                                  mode="multiple"
                                  placeholder={t("select.organization")}
                                  {...selectProps}
                                />
                              </FilterDropdown>
                            )}
                        />
                        {/* <Table.Column
                            key="gender"
                            dataIndex="gender"
                            title={t("users.fields.gender.label")}
                            render={(value) =>
                                t(`users.fields.gender.${value}`)
                            }
                        /> */}
                        {/* <Table.Column
                            key="isActive"
                            dataIndex="isActive"
                            title={t("users.fields.isActive.label")}
                            render={(value) => <BooleanField value={value} />}
                        /> */}
                        <Table.Column
                            key="createdat"
                            dataIndex="createdat"
                            title={t("users.fields.createdAt")}
                            render={(value) => (
                                <DateField value={value} format="LLL" />
                            )}
                            sorter
                        />
                        <Table.Column<IProfile>
                            title={t("table.actions")}
                            render={(_, record) => (
                                <EditButton hideText onClick={() => editShow(record.id)} />
                            )}
                        />
                    </Table>
                </List>
            </Col>
      </Row>
      <CreateProfile drawerProps={createDrawerProps} formProps={createFormProps} saveButtonProps={createSaveButtonProps} />
      <EditProfile drawerProps={editDrawerProps} formProps={editFormProps} saveButtonProps={editSaveButtonProps} />
    </>
  );
};

const Filter: React.FC<{ formProps: FormProps }> = (props) => {
  const t = useTranslate();

  const { RangePicker } = DatePicker;

  return (
        <Form layout="vertical" {...props.formProps}>
          <Row gutter={[10, 0]} align="bottom">
            <Col xs={24} xl={24} md={12}>
              <Form.Item label={t("users.filter.search.label")} name="q">
                <Input
                  placeholder={t("users.filter.search.placeholder")}
                  prefix={<Icons.SearchOutlined />}
                />
              </Form.Item>
            </Col>
            <Col xs={24} xl={24} md={12}>
                    <Form.Item
                        label={t("users.filter.createdAt.label")}
                        name="createdAt"
                    >
                        <RangePicker style={{ width: "100%" }} />
                    </Form.Item>
            </Col>
              {/* <Col xs={24} xl={24} md={8}>
                  <Form.Item
                      label={t("users.filter.gender.label")}
                      name="gender"
                  >
                    <Select
                      allowClear
                      placeholder={t("users.filter.gender.placeholder")}
                      options={[
                        {
                          label: t("users.filter.gender.male"),
                          value: "Male",
                        },
                        {
                          label: t("users.filter.gender.female"),
                          value: "Female",
                        },
                      ]}
                    />
                    </Form.Item>
              </Col> */}
                {/* <Col xs={24} xl={24} md={8}>
                    <Form.Item
                        label={t("users.filter.isActive.label")}
                        name="isActive"
                    >
                        <Select
                            allowClear
                            placeholder={t("users.filter.isActive.placeholder")}
                            options={[
                                {
                                    label: t("users.filter.isActive.true"),
                                    value: "true",
                                },
                                {
                                    label: t("users.filter.isActive.false"),
                                    value: "false",
                                },
                            ]}
                        />
                    </Form.Item>
                </Col> */}
                <Col xs={24} xl={24} md={8}>
                    <Form.Item>
                        <Button
                            style={{ width: "100%" }}
                            htmlType="submit"
                            type="primary"
                        >
                            {t("users.filter.submit")}
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};
